import ListCandidates from './ListCandidates';

export default ListCandidates;
